{
  "MACROS": {
    "HEADER": "Makrá",
    "DESCRIPTION": "Makro je súbor uložených akcií, ktoré pomáhajú agentom zákazníckej podpory ľahko vykonávať úlohy. Agenti môžu definovať sadu akcií, ako je označenie konverzácie štítkom, odoslanie prepisu e-mailom, aktualizácia vlastného atribútu atď., a tieto akcie môžu spustiť jedným kliknutím.",
    "LEARN_MORE": "Zistiť viac o makrách",
    "HEADER_BTN_TXT": "Pridať nové makro",
    "HEADER_BTN_TXT_SAVE": "Uložiť makro",
    "LOADING": "Načítavajú sa makrá",
    "ERROR": "Niečo sa pokazilo. Skúste to prosím znova",
    "ORDER_INFO": "Makrá sa spustia v poradí, v akom pridáte akcie. Môžete ich usporiadať ich pretiahnutím za úchytku vedľa každého uzla.",
    "ADD": {
      "FORM": {
        "NAME": {
          "LABEL": "Názov makra",
          "PLACEHOLDER": "Zadajte názov pre vaše makro",
          "ERROR": "Na vytvorenie makra je potrebný názov"
        },
        "ACTIONS": {
          "LABEL": "Akcie"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Makro bolo úspešne pridané",
        "ERROR_MESSAGE": "Nepodarilo sa vytvoriť makro, skúste to prosím neskôr"
      }
    },
    "LIST": {
      "404": "Nenašli sa žiadne makrá",
      "TABLE_HEADER": {
        "NAME": "Meno",
        "CREATED BY": "Vytvoril(a)",
        "LAST_UPDATED_BY": "Naposledy aktualizoval(a)",
        "VISIBILITY": "Viditeľnosť"
      }
    },
    "DELETE": {
      "TOOLTIP": "Odstrániť makro",
      "CONFIRM": {
        "MESSAGE": "Určite chcete vymazať ",
        "YES": "Áno, vymazať",
        "NO": "Nie"
      },
      "API": {
        "SUCCESS_MESSAGE": "Makro bolo úspešne odstránené",
        "ERROR_MESSAGE": "Pri odstraňovaní makra nastala chyba. Skúste to prosím neskôr"
      }
    },
    "EDIT": {
      "TOOLTIP": "Upraviť makro",
      "API": {
        "SUCCESS_MESSAGE": "Makro bolo úspešne aktualizované",
        "ERROR_MESSAGE": "Nepodarilo sa aktualizovať makro, skúste to prosím neskôr"
      }
    },
    "EDITOR": {
      "START_FLOW": "Začiatok toku",
      "END_FLOW": "Koniec toku",
      "LOADING": "Načítava sa makro",
      "ADD_BTN_TOOLTIP": "Pridať novú akciu",
      "DELETE_BTN_TOOLTIP": "Odstrániť akciu",
      "VISIBILITY": {
        "LABEL": "Viditeľnosť makra",
        "GLOBAL": {
          "LABEL": "Verejné",
          "DESCRIPTION": "Toto makro je verejne dostupné všetkým agentom v tomto účte."
        },
        "PERSONAL": {
          "LABEL": "Súkromné",
          "DESCRIPTION": "Toto makro bude súkromné iba pre vás a nebude dostupné ostatným."
        }
      }
    },
    "EXECUTE": {
      "BUTTON_TOOLTIP": "Spustiť",
      "PREVIEW": "Náhľad makra",
      "EXECUTED_SUCCESSFULLY": "Makro bolo úspešne spustené"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Kľúč atribútu je povinný",
      "FILTER_OPERATOR_REQUIRED": "Operátor filtra je povinný",
      "VALUE_REQUIRED": "Hodnota je povinná",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998",
      "ACTION_PARAMETERS_REQUIRED": "Parametre akcie sú povinné",
      "ATLEAST_ONE_CONDITION_REQUIRED": "Vyžaduje sa aspoň jedna podmienka",
      "ATLEAST_ONE_ACTION_REQUIRED": "Vyžaduje sa aspoň jedna akcia",
      "VALUE_MUST_BE_BETWEEN_0_AND_998": "Hodnota musí byť medzi 0 a 998"
    },
    "ACTIONS": {
      "ASSIGN_TEAM": "Priradiť tím",
      "ASSIGN_AGENT": "Priradiť agenta",
      "ADD_LABEL": "Pridať štítok",
      "REMOVE_LABEL": "Odstrániť štítok",
      "REMOVE_ASSIGNED_TEAM": "Odstrániť priradený tím",
      "SEND_EMAIL_TRANSCRIPT": "Odoslať e-mailový prepis",
      "MUTE_CONVERSATION": "Stlmiť konverzáciu",
      "SNOOZE_CONVERSATION": "Odložiť konverzáciu",
      "RESOLVE_CONVERSATION": "Vyriešiť konverzáciu",
      "SEND_ATTACHMENT": "Odoslať prílohu",
      "SEND_MESSAGE": "Odoslať správu",
      "CHANGE_PRIORITY": "Zmeniť prioritu",
      "ADD_PRIVATE_NOTE": "Pridať súkromnú poznámku",
      "SEND_WEBHOOK_EVENT": "Odoslať udalosť webhooku"
    },
    "ACTION_VALUES": {
      "SELF": "Ja"
    }
  }
}
